
import { defineComponent } from "vue";
import LogoIcon from "@/components/icons/LogoIcon.vue";
import Socials from "@/components/base-page/Socials.vue";

export default defineComponent({
  name: "Header",
  components: { Socials, LogoIcon },
});
